<template>
  <div class="settingModal">
    <Modal
      :width="1240"
      v-model="isShowModal"
      @on-visible-change="visibleChange"
      :title="isType ? 'Asset type setting' : 'Asset system setting'"
      footer-hide
    >
      <Button
        type="primary"
        icon="md-add"
        class="add_btn"
        @click="isType ? addType() : addSystem()"
      >
        Add
      </Button>
      <div class="tableData">
        <Card :padding="0">
          <Table :columns="columnsData" :data="dataArr"></Table>
        </Card>
      </div>
      <!-- <div slot="footer"></div> -->
    </Modal>
    <!-- add and edit type modal -->
    <Modal
      v-model="isShowtypeModal"
      :title="isAddType ? 'Add Type' : 'Edit Type'"
      footer-hide
    >
      <Form ref="typeObj" :model="typeObj" :rules="ruleValidate">
        <FormItem label="Name" prop="name">
          <Input
            placeholder="Please enter name"
            v-model.trim="typeObj.name"
            :disabled="!typeObj.isCustom"
          ></Input>
        </FormItem>
        <FormItem label="Code" prop="code">
          <Input v-model.trim="typeObj.code"></Input>
        </FormItem>
        <FormItem label="Description" prop="description">
          <Input
            placeholder="Description"
            v-model.trim="typeObj.description"
          ></Input>
        </FormItem>
      </Form>
      <div class="footerBtn">
        <Button size="large" @click="restFn">Reset</Button>
        <Button
          type="primary"
          size="large"
          @click="isAddType ? addTypeFn() : editTypeFn()"
          >{{ isAddType ? "Add" : "Save" }}</Button
        >
      </div>
    </Modal>
    <!-- delete type modal -->
    <Modal title="Delete type" v-model="deleteTypeModal">
      <span class="deleteTypeModals">
        All places using this item will be cleared. Please confirm to delete it.
      </span>
      <div slot="footer" class="footerBtn">
        <Button size="large" @click="cancelFn">Cancel</Button>
        <Button size="large" @click="deleteTypeFn" type="error">Delete</Button>
      </div>
    </Modal>

    <!-- add and edit system modal -->
    <Modal
      v-model="isShowSystemModal"
      :title="isAddSystem ? 'Add System' : 'Edit System'"
    >
      <Form ref="systemObj" :model="systemObj" :rules="ruleValidate">
        <FormItem label="Name" prop="name">
          <Input
            placeholder="Please enter name"
            v-model.trim="systemObj.name"
            :disabled="!systemObj.isCustom"
          ></Input>
        </FormItem>
        <FormItem label="Code" prop="code">
          <Input v-model.trim="systemObj.code"></Input>
        </FormItem>
        <FormItem label="Description" prop="description">
          <Input
            placeholder="Description"
            v-model.trim="systemObj.description"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer" class="footerBtn">
        <Button size="large" @click="restFn">Reset</Button>
        <Button
          type="primary"
          size="large"
          @click="isAddSystem ? addSystemFn() : editSystemFn()"
          >{{ isAddSystem ? "Add" : "Save" }}</Button
        >
      </div>
    </Modal>
    <!-- delete system modal -->
    <Modal title="Delete system" v-model="deleteSystemModal">
      <span class="deleteTypeModals">
        Please confirm to delete this item.
      </span>
      <div slot="footer" class="footerBtn">
        <Button size="large" @click="cancelFn">Cancel</Button>
        <Button size="large" @click="deleteSystemFn" type="error"
          >Delete</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import apiRoutes from "@/config/API_ROUTER";

export default {
  name: "SettingModal",
  props: {
    showModalValue: { type: String, default: "" },
    isShowSettingModal: { type: Boolean, default: false },
    typeList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    systemList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    dataArrLegth() {
      return this.dataArr.length;
    },
  },
  watch: {
    showModalValue(name) {
      //   // console.log(name);

      this.initData();
      switch (name) {
        case "Asset System":
          this.isType = false;
          break;
        case "Asset Type":
          this.isType = true;
          break;
        default:
          break;
      }
    },
    isShowSettingModal(n) {
      if (n) {
        this.isShowModal = true;
      }
    },
    typeList() {
      // console.log(value);
      this.initData();
    },
    systemList() {
      // console.log(value);
      this.initData();
    },
    dataArrLegth() {
      // console.log(n);
    },
    isType() {
      // console.log(value);
      this.initData();
    },
  },
  data() {
    return {
      showSettingModal: false,
      isShowModal: false,
      isType: false,
      columnsData: [
        {
          title: "Number",
          type: "index",

          align: "center",
        },
        {
          title: "Name",
          key: "name",
        },
        {
          title: "Code",
          key: "code",
        },
        {
          title: "Description",
          key: "description",
        },
        {
          title: "Action",
          key: "action",
          render: (h, params) => {
            return h("div", [
              h("i", {
                class: "mdi mdi-border-color",
                style: {
                  marginRight: "15px",
                  color: "#ED7B2F",
                  "font-size": "16px",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    // console.log(event);
                    // event.stopPropagation();
                    // this.showEditModal(params);
                    if (this.isType) {
                      this.editType(params.row);
                    } else {
                      this.editSystem(params.row);
                    }
                  },
                },
              }),
              h("i", {
                class: "mdi mdi-trash-can-outline",
                style: {
                  marginRight: "15px",
                  color: "#ED7B2F",
                  "font-size": "16px",
                  cursor: "pointer",
                  display: params.row.isCustom ? "inline-block" : "none",
                },
                on: {
                  click: () => {
                    // console.log(event);
                    // event.stopPropagation();
                    // console.log(params);
                    if (this.isType) {
                      this.deleteType(params);
                    } else {
                      this.deleteSystem(params);
                    }
                  },
                },
              }),
            ]);
          },
        },
      ],
      dataArr: [],
      isShowtypeModal: false,
      isAddType: false,
      typeObj: {
        id: null,
        name: "",
        code: "",
        description: "",
        projectId: "2d3919b5-98f8-4cb0-99f6-08d9dbfc1b76",
        isCustom: false,
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "The name cannot be empty",
            trigger: "blur",
          },
        ],
      },
      // show delete type modal
      deleteTypeModal: false,
      /* system */
      isAddSystem: false,
      isShowSystemModal: false,
      systemObj: {
        id: null,
        name: "",
        code: "",
        description: "",
        projectId: "2d3919b5-98f8-4cb0-99f6-08d9dbfc1b76",
        isCustom: true,
      },
      deleteSystemModal: false,
    };
  },
  methods: {
    initData() {
      this.dataArr = [];
      // console.log(this.dataArr);
      if (this.isType && this.typeList && this.typeList.length > 0) {
        this.dataArr = JSON.parse(JSON.stringify(this.typeList));
      } else if (
        !this.isType &&
        this.systemList &&
        this.systemList.length > 0
      ) {
        this.dataArr = JSON.parse(JSON.stringify(this.systemList));
      }
      // console.log(this.systemList);
    },
    visibleChange() {
      // console.log(status);
      this.$emit("closeModal", true);
    },
    addType() {
      this.typeObj = {
        id: null,
        name: "",
        code: "",
        description: "",
        projectId: "2d3919b5-98f8-4cb0-99f6-08d9dbfc1b76",
        isCustom: true,
      };
      // console.log("type");
      this.isShowtypeModal = true;
      this.isAddType = true;
    },
    addTypeFn() {
      // // console.log(this.typeObj);
      this.$refs.typeObj.validate((valid) => {
        if (valid) {
          const tempObj = {};
          Object.keys(this.typeObj).forEach((key) => {
            if (this.typeObj[key]) {
              tempObj[key] = this.typeObj[key];
            }
          });
          // console.log(tempObj);
          const url = apiRoutes.TypeAttr;
          this.$http
            .post(url, tempObj)
            .then((res) => {
              if (res.data.message === "Succeed") {
                this.isShowtypeModal = false;
                this.$Message.success("Success!");
                this.$emit("isAddTypeSuccess", "add");
                this.initData();
              } else {
                this.$Notice.error({
                  title: "Error",
                  desc: res.data.message,
                  duration: 25,
                });
              }
            })
            .catch((e) => {
              this.$Notice.error({
                title: "Error",
                desc: e.Message,
                duration: 25,
              });
            });
        } else {
          this.$Message.error("Please input");
        }
      });
    },
    editType(row) {
      // console.log(row);
      Object.keys(row).forEach((key) => {
        Object.keys(this.typeObj).forEach((subKey) => {
          if (key === subKey) {
            this.typeObj[subKey] = row[key];
          }
        });
      });
      // console.log(this.typeObj);
      this.isShowtypeModal = true;
      this.isAddType = false;
    },

    editTypeFn() {
      this.$refs.typeObj.validate((valid) => {
        if (valid) {
          const url = apiRoutes.TypeAttr;
          const params = {
            name: this.typeObj.name,
            code: this.typeObj.code,
            description: this.typeObj.description,
          };
          // console.log(this.typeObj.id);
          this.$http
            .put(`${url}/${this.typeObj.id}`, params)
            .then((res) => {
              if (res.data.message === "Succeed") {
                this.isShowtypeModal = false;
                this.$Message.success("Success!");
                this.$emit("isAddTypeSuccess", "edit");
                this.initData();
              } else {
                this.$Notice.error({
                  title: "Error",
                  desc: res.data.message,
                  duration: 25,
                });
              }
            })
            .catch((e) => {
              this.$Notice.error({
                title: "Error",
                desc: e.Message,
                duration: 25,
              });
            });
        } else {
          this.$Message.error("Please input");
        }
      });
    },
    deleteType(params) {
      this.typeObj.id = params.row.id;
      this.deleteTypeModal = true;
    },
    deleteTypeFn() {
      const url = apiRoutes.TypeAttr;
      this.$http
        .delete(`${url}/${this.typeObj.id}`)
        .then((res) => {
          // console.log(res);
          if (res.data.data) {
            this.deleteTypeModal = false;
            this.$Message.success("Success!");
            this.$emit("isAddTypeSuccess", "delete");
            this.initData();
          } else {
            // this.$Message.error(res.data.Message);
            this.$Notice.error({
              title: "Error",
              desc: res.data.Message,
              duration: 25,
            });
          }
        })
        .catch((e) => {
          this.$Notice.error({
            title: "Error",
            desc: e.Message,
            duration: 25,
          });
        });
    },
    /* system */
    addSystem() {
      this.systemObj = {
        id: null,
        name: "",
        code: "",
        description: "",
        projectId: "2d3919b5-98f8-4cb0-99f6-08d9dbfc1b76",
        isCustom: true,
      };
      // console.log("system");
      this.isShowSystemModal = true;
      this.isAddSystem = true;
    },
    addSystemFn() {
      // console.log(this.systemObj, "system");
      this.$refs.systemObj.validate((valid) => {
        if (valid) {
          // console.log("success");
        } else {
          this.$Message.error("Fail!");
        }
      });
      const tempObj = {};
      Object.keys(this.systemObj).forEach((key) => {
        if (this.systemObj[key]) {
          tempObj[key] = this.systemObj[key];
        }
      });
      // console.log(tempObj);
      const url = apiRoutes.SystemAttr;
      this.$http
        .post(url, tempObj)
        .then((res) => {
          if (res.data.message === "Succeed") {
            this.isShowSystemModal = false;
            this.$Message.success("Success!");
            this.$emit("isAddSystemSuccess", "add");
            this.initData();
          } else {
            // this.$Message.error(res.data.message);
            this.$Notice.error({
              title: "Error",
              desc: res.data.message,
              duration: 25,
            });
          }
        })
        .catch((e) => {
          this.$Notice.error({
            title: "Error",
            desc: e.Message,
            duration: 25,
          });
        });
    },
    editSystem(row) {
      // console.log(row);
      Object.keys(row).forEach((key) => {
        Object.keys(this.systemObj).forEach((subKey) => {
          if (key === subKey) {
            this.systemObj[subKey] = row[key];
          }
        });
      });
      // console.log(this.systemObj);
      this.isShowSystemModal = true;
      this.isAddSystem = false;
    },

    editSystemFn() {
      const url = apiRoutes.SystemAttr;
      const params = {
        name: this.systemObj.name,
        code: this.systemObj.code,
        description: this.systemObj.description,
      };
      // console.log(this.systemObj.id);
      this.$http
        .put(`${url}/${this.systemObj.id}`, params)
        .then((res) => {
          if (res.data.message === "Succeed") {
            this.isShowSystemModal = false;
            this.$Message.success("Success!");
            this.$emit("isAddSystemSuccess", "edit");
            this.initData();
          } else {
            // this.$Message.error(res.data.message);
            this.$Notice.error({
              title: "Error",
              desc: res.data.message,
              duration: 25,
            });
          }
        })
        .catch((e) => {
          this.$Notice.error({
            title: "Error",
            desc: e.Message,
            duration: 25,
          });
        });
    },
    deleteSystem(params) {
      this.systemObj.id = params.row.id;
      this.deleteSystemModal = true;
    },
    deleteSystemFn() {
      const url = apiRoutes.SystemAttr;
      this.$http
        .delete(`${url}/${this.systemObj.id}`)
        .then((res) => {
          // console.log(res);
          if (res.data.data) {
            this.deleteSystemModal = false;
            this.$Message.success("Success!");
            this.$emit("isAddSystemSuccess", "delete");
            this.initData();
          } else {
            // this.$Message.error(res.data.Message);
            this.$Notice.error({
              title: "Error",
              desc: res.data.Message,
              duration: 25,
            });
          }
        })
        .catch((e) => {
          this.$Notice.error({
            title: "Error",
            desc: e.Message,
            duration: 25,
          });
        });
    },
    // 重置
    restFn() {
      // console.log(name);
      if (this.isType) {
        if (this.typeObj.isCustom) {
          this.typeObj.name = "";
          this.typeObj.code = "";
          this.typeObj.description = "";
        } else {
          this.typeObj.code = "";
          this.typeObj.description = "";
        }
      } else if (this.systemObj.isCustom) {
        this.systemObj.name = "";
        this.systemObj.code = "";
        this.systemObj.description = "";
      } else {
        this.systemObj.code = "";
        this.systemObj.description = "";
      }
    },
    // 取消
    cancelFn() {
      this.deleteSystemModal = false;
      this.deleteTypeModal = false;
    },
  },
  mounted() {
    // this.initData();
  },
};
</script>

<style lang="less">
.add_btn {
  margin-left: 38px;
  margin-bottom: 16px;
}
.tableData {
  padding: 0 38px;
  padding-bottom: 10px;
  width: 100%;
}
.footerBtn {
  // display: flex;
  // justify-content: space-around;
}
.deleteTypeModals {
  display: inline-block;
  font-size: 22px;
  line-height: 32px;
  color: #e34d59;
  width: 100%;
  text-align: center;
}
.settingModal {
  .ivu-input-wrapper {
    display: inline-block !important;
  }
}
</style>
